import React, { Component } from 'react'
import { Col, Row,  FormGroup } from "react-bootstrap"
import moment from 'moment'
import {  Field,reduxForm,propTypes,formValueSelector,
          change,untouch,getFormSyncErrors } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import {  fetchActiveSeasons, saveSeasonDates, triggerSeason,resetDatesSettings } from "../../../redux/actions/action_seasonsettings"
import logo from '../../../images/PinStar-15PX.png'
import { renderDatePickerField } from '../../../modules/components/datepickercomponent'
import { warning, videoblue } from '../../../utils/sitecolors'
import { lblattrs10,lblattrs,inputattrs2 } from '../../../utils/style'
import ErrorList from './ErrorList'
import InfoSaved from './InfoSaved'

const datesTab = 1
const formName = 'seasondates'
class SeasonDates extends Component {
    static propTypes = {
        ...propTypes
    }
    constructor(props,context) {
        super(props,context)
        this.seasonOptions      = this.seasonOptions.bind(this)
        this.handleSaveDates    = this.handleSaveDates.bind(this)
        this.handleSetupSeason    = this.handleSetupSeason.bind(this)
        this.resetFields  = this.resetFields.bind(this)
        this.handleValueChange = this.handleValueChange.bind(this)
        this.handleSelectedSeasonChange = this.handleSelectedSeasonChange.bind(this)
        this.disableSave = this.disableSave.bind(this)
    }
    componentDidUpdate(){
        
        const {  initialize,datasaved,resetform,resetDatesSettings,settingsSaved,datesreset,resetDone,dispatch } = this.props

        if (datasaved) {
          
            initialize({}, true)
            settingsSaved(true,datesTab)
        }
        if(resetform == true){
            resetDatesSettings()
        }
        if(datesreset == true){
            dispatch(change(formName,'datesreset',false))
            resetDone()
        }
    }
    seasonOptions()
    {
       const { seasondates } = this.props
       const seasondatesarray = Object.values(seasondates)
       const option = seasondatesarray.map((season) => {
                 return (<option key={season.id} value={season.id}>{season.description}</option>)
        })
       return option
    }
    handleValueChange(){
        const { dispatch, settingsSaved } = this.props
        dispatch(change(formName,'datasaved',false))
        settingsSaved(false,datesTab)
    }
    handleSaveDates() {

      const { seasondates,   saveSeasonDates, settingsseason,dispatch } = this.props
      const seasonId =  settingsseason
      const season = seasondates[settingsseason]      
      const dates = {
        registrationOpensOn:season.registrationOpensOn,
        firstSemesterStartDate:season.firstSemesterStartDate,
        secondSemesterStartDate:season.secondSemesterStartDate,
        rankingEndDate:season.rankingEndDate,
        rankingStartDate:season.rankingStartDate,
        firstSemesterExceptionExclusionDate:season.firstSemesterExceptionExclusionDate,
        secondSemesterExceptionExclusionDate:season.secondSemesterExceptionExclusionDate,
        rollOverDate:season.rollOverDate,
        seasonId
      }
      dispatch(change('seasondates', 'savingdata',true))
      saveSeasonDates(seasonId,dates)
    }
    handleSetupSeason() {
        const { triggerSeason, settingsseason,dispatch } = this.props
        const seasonId =  settingsseason
        const season = {
            SeasonId:seasonId
        }
       
        dispatch(change('seasondates', 'isSettingSeason',true))
        triggerSeason(seasonId,season)
    }
    handleSelectedSeasonChange = evt => {
         const { onSeasonChange,seasondates } = this.props
         const seasonId    = evt.target.value
    
         const { description, isSeasonSet } = seasondates[seasonId]
         onSeasonChange(parseInt(seasonId),description,isSeasonSet)
    }
    resetFields = (formName, fieldsObj) => {
        Object.keys(fieldsObj).forEach(fieldKey => {
           //reset the field's value
           // this.props.dispatch(change(formName, fieldKey, fieldsObj[fieldKey]));
           //reset the field's error
            this.props.dispatch(untouch(formName, fieldKey));
        })
    }

    isSeasonSet(){
        const {  seasondates, settingsseason } = this.props
        let isSeasonSet = true

        if(seasondates){
             isSeasonSet = seasondates[settingsseason].isSeasonSet
        }
        return isSeasonSet
    }

    disableSave() {
      
      const { datasaved,datesreset ,seasondates ,settingsseason,syncErrors } = this.props
      let isSeasonSet = true
      const errors    =  Object.values(syncErrors)  
      
      if(seasondates){
           isSeasonSet = seasondates[settingsseason].isSeasonSet
      }
    //  console.log('Disable save  datasaved,datesreset,isSeasonSet, errors.length', datasaved,datesreset,!isSeasonSet, errors.length)
      return   ((datasaved == undefined) || (datasaved == true) || errors.length > 0 || !isSeasonSet || datesreset)
    }
    render() {
 
       const {  seasondates, settingsseason,savingdata,isSettingSeason, datasaved ,seasontriggered, syncErrors } = this.props
 
       const season      = `seasondates[${settingsseason}]`
       const isSeasonSet = this.isSeasonSet()
       
       const errors =  Object.values(syncErrors)

       return (
            <Row className="center-block center-text">
               
                    <form name='seasondates' className="form-horizontal" sm={12}  style={{ padding:'0',margin:'0' }} >
                        <Col sm={12}>
                            {
                                (errors.length > 0) && <ErrorList errors={errors}/>
                            }
                            <FormGroup>
                                <label className={lblattrs} style={{ color:videoblue,fontSize:'120%' }}> 
                                    <img src={logo} style={{ maxWidth:'30px', marginTop:'-3px' }} />&nbsp;&nbsp;Season Year
                                </label>
                                <Col sm={8}>
                                    <Field name='settingsseason' 
                                        component="select" 
                                        onChange={this.handleSelectedSeasonChange}
                                        style={{ minHeight:'35px',paddingLeft:'15px', minWidth:'21.5%', borderColor:'#C3C3C3', borderRadius:'3px' }} 
                                    >
                                      { seasondates != undefined && this.seasonOptions() } 
                                    </Field>
                                </Col>
                            </FormGroup>   
                            <Field
                                label='Registration opens on'
                                labelattrs={lblattrs}
                                inputattrs={inputattrs2}
                                title='Registration opens on'
                                name={`${season}.registrationOpensOn`}
                                component={renderDatePickerField}
                                placeholder='mm-dd-yyyy'
                                onChange={this.handleValueChange}
                                disabled = { !isSeasonSet }
                            />                                                           
                            <Field
                                label='1st semester starts on'
                                labelattrs={lblattrs}
                                inputattrs={inputattrs2}
                                title='Event start date'
                                name={`${season}.firstSemesterStartDate`}
                                component={renderDatePickerField}
                                placeholder='mm-dd-yyyy'
                                onChange={this.handleValueChange}
                                disabled = { !isSeasonSet }
                            /> 
                            <Field
                                label='Start ranking week 1'
                                labelattrs={lblattrs}
                                inputattrs={inputattrs2}
                                title='Event start date'
                                name={`${season}.rankingStartDate`}
                                component={renderDatePickerField}
                                placeholder='mm-dd-yyyy'
                                onChange={this.handleValueChange}
                                disabled = { !isSeasonSet }
                            /> 
                            <Field
                                label='1st semester exclude exceptions till'
                                labelattrs={lblattrs}
                                inputattrs={inputattrs2}
                                title='Event start date'
                                name={`${season}.firstSemesterExceptionExclusionDate`}
                                component={renderDatePickerField}
                                placeholder='mm-dd-yyyy'
                                onChange={this.handleValueChange}
                                disabled = { !isSeasonSet }
                            />
                            <Field
                                label='2nd semester starts on'
                                labelattrs={lblattrs}
                                inputattrs={inputattrs2}
                                title='Event start date'
                                name={`${season}.secondSemesterStartDate`}
                                component={renderDatePickerField}
                                placeholder='mm-dd-yyyy'
                                onChange={this.handleValueChange}
                                disabled = { !isSeasonSet }
                            />
                            <Field
                                label='2nd semester exclude exceptions till'
                                labelattrs={lblattrs}
                                inputattrs={inputattrs2}
                                title='Event start date'
                                name={`${season}.secondSemesterExceptionExclusionDate`}
                                component={renderDatePickerField}
                                placeholder='mm-dd-yyyy'
                                onChange={this.handleValueChange}
                                disabled = { !isSeasonSet }
                            /> 
                            <Field
                                label='End ranking date'
                                labelattrs={lblattrs}
                                inputattrs={inputattrs2}
                                title='Event start date'
                                name={`${season}.rankingEndDate`}
                                component={renderDatePickerField}
                                placeholder='mm-dd-yyyy'
                                onChange={this.handleValueChange}
                                disabled = { !isSeasonSet }
                            />
                            <Field
                                label='Rollover date'
                                labelattrs={lblattrs}
                                inputattrs={inputattrs2}
                                title='Season rollover date'
                                name={`${season}.rollOverDate`}
                                component={renderDatePickerField}
                                placeholder='mm-dd-yyyy'
                                onChange={this.handleValueChange}
                                disabled = { !isSeasonSet }
                            />  
                            <FormGroup>
                                <label className={lblattrs10} style={{ fontSize: '105%', color: warning, fontWeight: 'bold', paddingLeft: '7%' }}>* Setup Season will copy all settings from the previous season. To make season changes, see the below sections. </label>
                            </FormGroup>
                            <FormGroup>
                                <Col lgOffset={2} lg={5}>
                                    <button type='button' className="btn btn-primary" style={{ marginLeft: '20px' }} onClick={this.handleSaveDates}  disabled={this.disableSave()}>
                                        <i className={savingdata == true ? 'fa fa-spinner fa-spin' : "fa fa-calendar"} aria-hidden="true" /> &nbsp;&nbsp;Save Dates
                                    </button>
                                    <button type="button" className="btn btn-primary" style={{ marginLeft: '15px' }} onClick={this.handleSetupSeason} disabled={ isSeasonSet }>
                                        <i className={isSettingSeason ? 'fa fa-spinner fa-spin' : "fa fa-cogs"} aria-hidden="true" /> &nbsp;&nbsp;Setup Season
                                    </button>
                                    {
                                        datasaved && (<InfoSaved section='Season dates' />)
                                    }
                                    {
                                        seasontriggered && (<InfoSaved custommessage='Season has been successfully triggered.' />)
                                    }
                                </Col>
                            </FormGroup>
                        </Col>
                    </form>     
                
            </Row>              
        )
    }
}

SeasonDates.propTypes = {
    handleSubmit: PropTypes.func,
    syncErrors:PropTypes.object,
    dispatch:PropTypes.func,
    initialize:PropTypes.func,
    reset:PropTypes.func,
    datasaved:PropTypes.bool,
    seasontriggered:PropTypes.bool,
    fetchActiveSeasons: PropTypes.func,
    saveSeasonDates: PropTypes.func,  
    triggerSeason:PropTypes.func,
    savingdata:PropTypes.bool,
    isSettingSeason:PropTypes.bool,
    seasonyear: PropTypes.string,
    seasondates:PropTypes.object,
    settingsseason:PropTypes.string,
    onSeasonChange:PropTypes.func,
    settingsSaved: PropTypes.func,
    resetform:PropTypes.bool,
    resetDatesSettings:PropTypes.func,
    resetDone:PropTypes.func,
    datesreset:PropTypes.bool
}

function mapStateToProps(state,ownProps) {
    const formName =  ownProps.form
    const selector = formValueSelector(formName)
    const settingsseason = selector(state,'settingsseason')
    const seasonyear     = selector(state,'seasonyear')
    const seasondates    = selector(state,'seasondates')
    const savingdata     = selector(state,'savingdata')
    const isSettingSeason    = selector(state,'isSettingSeason')
    const datasaved    = selector(state,'datasaved')
    const seasontriggered = selector(state,'seasontriggered')
    const syncErrors = getFormSyncErrors(formName)(state)
    const datesreset    = selector(state,'datesreset')
    return {
        seasondates,
        seasonyear,
        savingdata,
        settingsseason,
        isSettingSeason,
        datasaved,
        seasontriggered,
        syncErrors,
        datesreset
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchActiveSeasons,
        saveSeasonDates,
        triggerSeason,
        resetDatesSettings
      },dispatch)
}

function validate(values) {

    const { settingsseason,seasondates } = values
    const errors = {}
   
    if(seasondates && settingsseason) {
       
        const season = seasondates[settingsseason]
        let errorCounter = 0

        // All dates need to be provided
        if(season.isSeasonSet) 
        {
       
            if (!season.firstSemesterExceptionExclusionDate) {
                errors[errorCounter++] = '1st semester exception exclusion date is required'
            }
            if (!season.secondSemesterExceptionExclusionDate) {
                errors[errorCounter++] = '2nd semester exception exclusion date is required'
            }
            if (!season.rankingEndDate) {
                errors[errorCounter++] = 'Ranking end date is required'
            }
            if (!season.rollOverDate) {
                errors[errorCounter++] = 'Rollover date is required'
            }
            const registrationOpensOn                  = moment(season.registrationOpensOn)
            const firstSemesterStartDate               = moment(season.firstSemesterStartDate)
            const rollOverDate                         = moment(season.rollOverDate)
            const rankingStartDate                     = moment(season.rankingStartDate)
            const firstSemesterExceptionExclusionDate  = moment(season.firstSemesterExceptionExclusionDate)
            const secondSemesterStartDate              = moment(season.secondSemesterStartDate)
            const secondSemesterExceptionExclusionDate = moment(season.secondSemesterExceptionExclusionDate)
            const rankingEndDate                       = moment(season.rankingEndDate)
        
            // 1st semester date validations
            if (!season.registrationOpensOn) {
                errors[errorCounter++] = 'Registration open date is required'
            }
            if (!season.firstSemesterStartDate) {
                errors[errorCounter++] = '1st semester start date is required'
            }
            else if (firstSemesterStartDate > rollOverDate) {
                errors[errorCounter++]  = '1st semester start date cannot be later than the roll over date'
            }
            else if (firstSemesterStartDate > rankingStartDate) {
                errors[errorCounter++]  = '1st semester start date cannot be later than the ranking start date'
            }
            else if (firstSemesterStartDate > firstSemesterExceptionExclusionDate) {
                errors[errorCounter++]  = '1st semester start date cannot be later than the exception exclusion date'
            }
            else if (firstSemesterStartDate > secondSemesterStartDate) {
                errors[errorCounter++]  = '1st semester start date cannot be later than the 2nd semester start date'
            }
            else if (firstSemesterStartDate > secondSemesterExceptionExclusionDate) {
                errors[errorCounter++]  = '1st semester start date cannot be later than the 2nd semester exception exclusion date'
            }
            else if (firstSemesterStartDate > rankingEndDate) {
                errors[errorCounter++]  = '1st semester start date cannot be later than the ranking end date'
            }

            // 2nd semester start date validations
            if (!season.secondSemesterStartDate) {
                errors[errorCounter++] = '2nd semester start date is required'
            }
            else  if (secondSemesterStartDate > rollOverDate) {
                errors[errorCounter++]  = '2nd semester start date cannot be later than the roll over date'
            }
            else if (secondSemesterStartDate > rankingEndDate) {
                errors[errorCounter++]  = '2nd semester start date cannot be later than the ranking end date'
            }
            else if (secondSemesterStartDate > secondSemesterExceptionExclusionDate) {
                errors[errorCounter++]  = '2nd semester start date cannot be later than the exception exclusion date'
            }
        
            // ranking start validation
            if (!season.rankingStartDate) {
                errors[errorCounter++] = 'Start ranking date is required'
            }
            else  if (registrationOpensOn > firstSemesterStartDate) {
                errors[errorCounter++]  = 'Registration open date cannot be later than the first semester start date'
            }
            else  if (rankingStartDate> rollOverDate) {
                errors[errorCounter++]  = 'Ranking start date cannot be later than the roll over date'
            }
            else if (rankingStartDate > rankingEndDate) {
                errors[errorCounter++]  = 'Ranking start date cannot be later than the ranking end date'
            }
            else if (rankingStartDate > secondSemesterExceptionExclusionDate) {
                errors[errorCounter++]  = 'Ranking start date cannot be later than the 2nd semester exception exclusion date'
            }
        }
        else {
            errors[errorCounter++]  = "Initiate the season by clicking 'Setup season'"
        }
    }
    return errors
} 
export default reduxForm({
  validate,
  form:formName,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: false,
  enableReinitialize: true
})(connect(mapStateToProps,mapDispatchToProps)(SeasonDates))




// WEBPACK FOOTER //
// ./src/containers/season/Components/SeasonDates.js